module.exports = __webpack_public_path__ + "img/3.8e67a39d.jpg";